export const PLACEHOLDER_DESCRIPTION =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent varius mauris quis fermentum eleifend. Phasellus et interdum est, non commodo libero. Maecenas bibendum gravida nisi, sit amet finibus nisl porta at. Nunc ut pellentesque eros. Duis in laoreet felis.";
export const NOT_APPLICABLE = "N/A";
export const DEFAULT_HYPERLINK_DISPLAY_TEXT = "Link Title";
export const DEFAULT_HYPERLINK_URL = "http://example.com";
export const MISSING_TENANT_MESSAGE_LINE1 =
  "You have used an incorrect URL to reach this site.";
export const MISSING_TENANT_MESSAGE_LINE2_PREFIX =
  "Please obtain the correct URL from ";
export const MISSING_TENANT_MESSAGE_COMPANY = "Dark Matter Technologies.";
export const MISSING_TENANT_MESSAGE = `${MISSING_TENANT_MESSAGE_LINE1}\n${MISSING_TENANT_MESSAGE_LINE2_PREFIX}${MISSING_TENANT_MESSAGE_COMPANY}`;
export const ERROR = "error";
export const SUCCESS = "success";

/** Top-centered ActionSnackbar width. */
export const TOP_CENTER_SNACKBAR_WIDTH = { xs: "90%", md: "50%" };

/** Cap width for long top-center messages (e.g. payment scheduling errors). */
export const TOP_CENTER_SNACKBAR_MAX_WIDTH = 560;

export const GENERIC_ERROR_MESSAGE = "An unexpected error has occured";
export const DEFAULT_MORNING_GREETING = "Good Morning";
export const DEFAULT_AFTERNOON_GREETING = "Good Afternoon";
export const DEFAULT_EVENING_GREETING = "Good Evening";
export const DEFAULT_USER_NAME = "Dear Customer";

export const NON_NEGATIVE_AMOUNT_ERROR_MESSAGE = "Amount cannot be negative";

// Responsive Layout Constants
export const RESPONSIVE_PADDING = {
  MOBILE: "24px 20px 100px 20px",
  TABLET: "24px 20px 100px 20px",
  DESKTOP: "25px 100px",
  MOBILE_BANNER: "0 20px 100px 20px",
  DESKTOP_BANNER: "0 100px 25px 100px",
  MOBILE_CONTENT: "15px 0",
  DESKTOP_CONTENT: "25px"
};